import { render, staticRenderFns } from "./match-text-image.vue?vue&type=template&id=3545e3fb&scoped=true"
import script from "./match-text-image.vue?vue&type=script&lang=js"
export * from "./match-text-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545e3fb",
  null
  
)

export default component.exports